module.exports = "<app-layout-header></app-layout-header>\n<app-alert></app-alert>\n<router-outlet></router-outlet>\n<app-layout-footer></app-layout-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main